export default "__VITE_ASSET__CAEP28x0__"